import _objectSpread from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var DEFAULT_OPTIONS = {
  disableNormalization: false
};
export var createPeriodicWaveConstructor = function createPeriodicWaveConstructor(createNativePeriodicWave, getNativeContext, periodicWaveStore, sanitizePeriodicWaveOptions) {
  return /*#__PURE__*/function () {
    function PeriodicWave(context, options) {
      _classCallCheck(this, PeriodicWave);
      var nativeContext = getNativeContext(context);
      var mergedOptions = sanitizePeriodicWaveOptions(_objectSpread({}, DEFAULT_OPTIONS, options));
      var periodicWave = createNativePeriodicWave(nativeContext, mergedOptions);
      periodicWaveStore.add(periodicWave);
      // This does violate all good pratices but it is used here to simplify the handling of periodic waves.
      return periodicWave;
    }
    _createClass(PeriodicWave, null, [{
      key: Symbol.hasInstance,
      value: function value(instance) {
        return instance !== null && typeof instance === 'object' && Object.getPrototypeOf(instance) === PeriodicWave.prototype || periodicWaveStore.has(instance);
      }
    }]);
    return PeriodicWave;
  }();
};